<template>
  <div>
    <span style="display:none">{{loadedScenario}}</span>
    <label class="label">Название сценария</label>
    <p class="control">
      <input v-model="scenario.name" class="input" type="text" placeholder="Введите название сценария">
    </p>
    <div>
      <label class="label">Вопрос</label>
      <p class="control">
        <input type="radio" v-model="scenario.parameters.mainGenerationState"
               v-bind:value="false"
               @change="onChangeGenerationState('mainGenerationState', 'mainQuestionAudio', 'mainGeneratedAudio', 'mainLoadedAudio', 'mainPlayer')">
        <label>Загрузить аудио</label>
        <br/>
        <input type="radio" v-model="scenario.parameters.mainGenerationState"
               v-bind:value="true"
               @change="onChangeGenerationState('mainGenerationState', 'mainQuestionAudio', 'mainGeneratedAudio', 'mainLoadedAudio', 'mainPlayer')">
        <label>Сгенерировать аудио</label>
      </p>

      <div v-if="scenario.parameters.mainGenerationState">
        <p class="control">
          <textarea v-model="scenario.parameters.mainQuestionText" class="textarea"></textarea>
          <div class="control is-grouped">
            <button class="button is-primary" v-on:click="genAudio('mainQuestionId', 'mainQuestionAudio', 'currentSpeakerMain', 'mainGeneratedAudio', 'mainQuestionText', 'mainLoading', 'Main question', 'currentEmotionMain', 'currentSpeedMain')">
              <span class="icon">
                <i class="fa fa-magic"></i>
              </span>
              <div class="loader spinner" v-if="tmp.mainLoading"></div>
              Сгенерировать аудио
            </button>

            <div class="select is-primary">
              <select v-model="tmp.currentSpeakerMain" class="form-control">
                <option v-for="speaker in speakerList">
                  {{speaker.value}}
                </option>
              </select>
            </div>
            <div class="select is-primary">
              <select v-model="tmp.currentEmotionMain" class="form-control">
                <option v-for="emotion in emotionList">
                  {{emotion.value}}
                </option>
              </select>
            </div>
            <p>
              <slider size="small" v-bind:value="tmp.currentSpeedMain" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedMain = $event"></slider>
              Скорость:&nbsp{{tmp.currentSpeedMain}}
            </p>

            <audio v-if="tmp.mainGeneratedAudio" :ref="'mainPlayer'">
              <source v-bind:src="scenario.parameters.mainQuestionAudio">
              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
            </audio>
            <audio-player v-if="tmp.mainGeneratedAudio" :file="scenario.parameters.mainQuestionAudio"/>
          </div>
        </p>
      </div>

      <div v-if="!scenario.parameters.mainGenerationState">
        <p class="control">
          <div class="control">
            <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('mainLoadedAudio')">
            <input style="display:none;" @input="loadAudio('mainLoadedAudio', 'mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'Main question', 'mainPlayer')" :id="`mainLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
            <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'Main question')">
            <audio v-if="tmp.mainLoadedAudio" :ref="'mainPlayer'">
              <source v-bind:src="scenario.parameters.mainQuestionAudio">
              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
            </audio>
            <audio-player v-if="tmp.mainLoadedAudio" :file="scenario.parameters.mainQuestionAudio"/>
          </div>
        </p>
      </div>
      <div v-if="scenario.parameters.mainQuestionId!=''">
        <p class="control">
          <button class="button is-link delete-button" v-on:click="deleteAudio('mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'mainGeneratedAudio')">
            <span class="icon">
              <i class="fa fa-minus-circle"></i>
            </span>
            <span>Удалить аудио</span>
          </button>
        </p>
      </div>
    </div>
    <div>
      <span class="second-layer positive-scenario">
        <label class="label">Сообщение при ответе да</label>
        <p class="control">
          <input type="radio" v-model="scenario.parameters.onYesGenerationState"
                   v-bind:value="false"
                   @change="onChangeGenerationState('onYesGenerationState', 'onYesAudio', 'onYesGeneratedAudio', 'onYesLoadedAudio', 'onYesPlayer')">
          <label>Загрузить аудио</label>
          <br/>
          <input type="radio" v-model="scenario.parameters.onYesGenerationState"
                   v-bind:value="true"
                   @change="onChangeGenerationState('onYesGenerationState', 'onYesAudio', 'onYesGeneratedAudio', 'onYesLoadedAudio', 'onYesPlayer')">
          <label>Сгенерировать аудио</label>
          <!--<toggle-button v-model="scenario.parameters.onYesGenerationState"
                           @change="onChangeGenerationState('onYesGenerationState', 'onYesAudio', 'onYesGeneratedAudio', 'onYesLoadedAudio', 'onYesPlayer')"
                           :labels="{checked: 'Загрузить аудио', unchecked: 'Сгенерировать аудио'}"
                           :color="{checked: '#7DCE94', unchecked: '#82C7EB'}"
                           :width="150"/>
          </p>-->

          <div v-if="scenario.parameters.onYesGenerationState">
            <p class="control">
              <textarea v-model="scenario.parameters.onYesText" class="textarea"></textarea>
              <div class="control is-grouped">
                <button class="button is-primary" v-on:click="genAudio('onYesId', 'onYesAudio', 'currentSpeakerYes', 'onYesGeneratedAudio', 'onYesText', 'onYesLoading', 'Yes question', 'currentEmotionYes', 'currentSpeedYes')">
                  <span class="icon">
                    <i class="fa fa-magic"></i>
                  </span>
                  <div class="loader spinner" v-if="tmp.onYesLoading"></div>
                  Сгенерировать аудио
                </button>

                <div class="select is-primary">
                  <select v-model="tmp.currentSpeakerYes" class="form-control">
                    <option v-for="speaker in speakerList">
                      {{speaker.value}}
                    </option>
                  </select>
                </div>
                <div class="select is-primary">
                  <select v-model="tmp.currentEmotionYes" class="form-control">
                    <option v-for="emotion in emotionList">
                      {{emotion.value}}
                    </option>
                  </select>
                </div>
                <p>
                  <slider size="small" v-bind:value="tmp.currentSpeedYes" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedYes = $event"></slider>
                  Скорость:&nbsp{{tmp.currentSpeedYes}}
                </p>

                <audio v-if="tmp.onYesGeneratedAudio" :ref="'onYesPlayer'">
                  <source v-bind:src="scenario.parameters.onYesAudio">
                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.onYesGeneratedAudio" :file="scenario.parameters.onYesAudio"/>
              </div>
            </p>
          </div>

          <div v-if="!scenario.parameters.onYesGenerationState">
            <p class="control">
              <div class="control">
                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('onYesLoadedAudio')">
                <input style="display:none;" @input="loadAudio('onYesLoadedAudio', 'onYesId', 'onYesAudio', 'onYesLoadedAudio', 'Yes question', 'onYesPlayer')" :id="`onYesLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
                <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('onYesId', 'onYesAudio', 'onYesLoadedAudio', 'Yes question')">
                <audio v-if="tmp.onYesLoadedAudio" :ref="'onYesPlayer'">
                  <source v-bind:src="scenario.parameters.onYesAudio">
                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.onYesLoadedAudio" :file="scenario.parameters.onYesAudio"/>
              </div>
            </p>
          </div>
          <div v-if="scenario.parameters.onYesId!=''">
            <p class="control">
              <button class="button is-link delete-button" v-on:click="deleteAudio('onYesId', 'onYesAudio', 'onYesLoadedAudio', 'onYesGeneratedAudio')">
                <span class="icon">
                  <i class="fa fa-minus-circle"></i>
                </span>
                <span>Удалить аудио</span>
              </button>
            </p>
          </div>
          <collapse>
            <collapse-item title="Отправить СМС" class="positive-scenario" :selected="scenario.parameters.onYesSMSText!=''">
              <p class="control">
                <textarea v-model="scenario.parameters.onYesSMSText" class="textarea"></textarea>
              </p>
            </collapse-item>
          </collapse>
        </p>
      </span>
    </div>

    <p style="padding: 10px;"></p>

    <div>
      <span class="second-layer negative-scenario">
        <label class="label">Сообщение при ответе нет</label>
        <p class="control">
          <input type="radio" v-model="scenario.parameters.onNoGenerationState"
                   v-bind:value="false"
                   @change="onChangeGenerationState('onNoGenerationState', 'onNoAudio', 'onNoGeneratedAudio', 'onNoLoadedAudio', 'onNoPlayer')">
          <label>Загрузить аудио</label>
          <br/>
          <input type="radio" v-model="scenario.parameters.onNoGenerationState"
               v-bind:value="true"
               @change="onChangeGenerationState('onNoGenerationState', 'onNoAudio', 'onNoGeneratedAudio', 'onNoLoadedAudio', 'onNoPlayer')">
          <label>Сгенерировать аудио</label>
        </p>

        <div v-if="scenario.parameters.onNoGenerationState">
          <p class="control">
            <textarea v-model="scenario.parameters.onNoText" class="textarea"></textarea>
            <div class="control is-grouped">
              <button class="button is-primary" v-on:click="genAudio('onNoId', 'onNoAudio', 'currentSpeakerNo', 'onNoGeneratedAudio', 'onNoText', 'onNoLoading', 'No question', 'currentEmotionNo', 'currentSpeedNo')">
                <span class="icon">
                  <i class="fa fa-magic"></i>
                </span>
                <div class="loader spinner" v-if="tmp.onNoLoading"></div>
                Сгенерировать аудио
              </button>

              <div class="select is-primary">
                <select v-model="tmp.currentSpeakerNo" class="form-control">
                  <option v-for="speaker in speakerList">
                    {{speaker.value}}
                  </option>
                </select>
              </div>
              <div class="select is-primary">
                <select v-model="tmp.currentEmotionNo" class="form-control">
                  <option v-for="emotion in emotionList">
                    {{emotion.value}}
                  </option>
                </select>
              </div>
              <p>
                <slider size="small" v-bind:value="tmp.currentSpeedNo" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedNo = $event"></slider>
                Скорость:&nbsp{{tmp.currentSpeedNo}}
              </p>

              <audio v-if="tmp.onNoGeneratedAudio" :ref="'onNoPlayer'">
                <source v-bind:src="scenario.parameters.onNoAudio">
                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
              </audio>
              <audio-player v-if="tmp.onNoGeneratedAudio" :file="scenario.parameters.onNoAudio"/>
            </div>
          </p>
        </div>

        <div v-if="!scenario.parameters.onNoGenerationState">
          <p class="control">
            <div class="control">
                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('onNoLoadedAudio')">
                <input style="display:none;" @input="loadAudio('onNoLoadedAudio', 'onNoId', 'onNoAudio', 'onNoLoadedAudio', 'No question', 'onNoPlayer')" :id="`onNoLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
                <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('onNoId', 'onNoAudio', 'onNoLoadedAudio', 'No question')">
              <audio v-if="tmp.onNoLoadedAudio" :ref="'onNoPlayer'">
                <source v-bind:src="scenario.parameters.onNoAudio">
                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
              </audio>
              <audio-player v-if="tmp.onNoLoadedAudio" :file="scenario.parameters.onNoAudio"/>
            </div>
          </p>
        </div>
        <div v-if="scenario.parameters.onNoId!=''">
          <p class="control">
            <button class="button is-link delete-button" v-on:click="deleteAudio('onNoId', 'onNoAudio', 'onNoLoadedAudio', 'onNoGeneratedAudio')">
              <span class="icon">
                <i class="fa fa-minus-circle"></i>
              </span>
              <span>Удалить аудио</span>
            </button>
          </p>
        </div>
      </span>
    </div>

    <p class="control">
      <button class="button is-primary" v-on:click="save(true)">
        <span class="icon">
          <i class="fa fa-floppy-o"></i>
        </span>
        <span>Сохранить</span>
      </button>
      <button class="button is-light" v-on:click="cancel">
        <span class="icon">
          <i class="fa fa-times-circle"></i>
        </span>
        <span>Закрыть</span>
      </button>
      <button class="button is-primary">
        <span class="icon">
          <i class="fa fa-calculator"></i>
        </span>
        <span>Рассчитать стоимость</span>
      </button>
      <button v-if="scenario.isReady" class="button is-success is-outlined" :disabled="true">
        <span class="icon">
          <i class="fa fa-info"></i>
        </span>
        <span>Подготовлен</span>
      </button>
      <button v-else class="button is-danger is-outlined" :disabled="true">
        <span class="icon">
          <i class="fa fa-info"></i>
        </span>
        <span>Не подготовлен</span>
      </button>
    </p>
  <modal :visible="showModal" :title=title @confirm="confirmAction" @close="closeModal"></modal>
  </div>
</template>

<script>
  import Cleave from 'vue-cleave'
  import AudioPlayer from '../../../components/audio-player.vue'
  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import Notification from 'vue-bulma-notification'
  import Message from 'vue-bulma-message'
  import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'
  import Modal from '../ModalAudio'
  import Slider from 'vue-bulma-slider'

  const NotificationComponent = Vue.extend(Notification)
  const openNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  }) => {
    return new NotificationComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const MessageComponent = Vue.extend(Message)
  const openMessage = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  }) => {
    return new MessageComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const api = '/api/scenarios'
  const audioGeneratorApi = '/audios/generate'
  const audioUploadApi = '/audios/reSave'
  const audioDeleteApi = '/audios'
  const PROFILES_API = '/api/profiles'

  export default {
    props: ['name', 'campaignid'],
    components: {
      Modal,
      Cleave,
      AudioPlayer,
      Message,
      Notification,
      Collapse,
      CollapseItem,
      Slider
    },
    computed: {
      ...mapGetters([
        'loadedScenario',
        'loggedId',
        'loggedUser',
        'authenticationToken'
      ])
    },
    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      changeRoute: function (e) {
        this.$router.push({path: '/scenarios' + e.target.value})
      },
      checkAudioDuration() {
        this.scenario.checkDuration = true
        var len = document.querySelectorAll('audio').length
        for (var i = 0; i < len; i++) {
          if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
            this.scenario.checkDuration = this.scenario.checkDuration && (document.querySelectorAll('audio')[i].duration > 0)
          }
        }
        return this.scenario.checkDuration
      },
      save (showMessage) {
        if (this.checkAudioDuration()) {
            this.scenario.parameters.mainSpeaker = this.tmp.currentSpeakerMain
            this.scenario.parameters.mainEmotion = this.tmp.currentEmotionMain
            this.scenario.parameters.mainSpeed = this.tmp.currentSpeedMain

            this.scenario.parameters.onYesSpeaker = this.tmp.currentSpeakerYes
            this.scenario.parameters.onYesEmotion = this.tmp.currentEmotionYes
            this.scenario.parameters.onYesSpeed = this.tmp.currentSpeedYes

            this.scenario.parameters.onNoSpeaker = this.tmp.currentSpeakerNo
            this.scenario.parameters.onNoEmotion = this.tmp.currentEmotionNo
            this.scenario.parameters.onNoSpeed = this.tmp.currentSpeedNo

            if (this.scenario.id === undefined) {
            this.saveNew(showMessage)
          } else {
            this.update(showMessage)
          }
        } else {
          this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности')
        }
      },
      saveNew(showMessage) {
        console.log('saving new scenario: ' + JSON.stringify(this.scenario))

        if (!this.scenario.parameters.mainGenerationState) {
          this.scenario.parameters.mainQuestionText = ''
        }
        if (!this.scenario.parameters.onYesGenerationState) {
          this.scenario.parameters.onYesText = ''
        }
        if (!this.scenario.parameters.onNoGenerationState) {
          this.scenario.parameters.onNoText = ''
        }

        this.$http.post(api, this.scenario, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.isSaved = true
            if (showMessage) {
              this.openNotificationWithType('info', 'Сценарий сохранен')
              this.$emit('set', this.scenario)
            }
            this.scenario = response.data
          }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ')
        })
      },
      update(showMessage) {
        console.log('updating scenario: ' + JSON.stringify(this.scenario))
        this.$http.put(api, this.scenario, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.isSaved = true
            this.scenario = response.data
            if (showMessage) {
              this.openNotificationWithType('info', 'Сценарий сохранен')
            }
          }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ')
        })
      },
      uploadFile(buttonId) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий')
        } else {
          document.getElementById(buttonId).click()
        }
      },
      genAudioRequest(maybeId, audioName, text, speaker, emotion, speed) {
        var request = {
          'client': this.scenario.client,
          'scenario': this.scenario.id,
          'audioName': audioName,
          'generator': 'yandex',
          'text': text,
          'parameters': {
            'speaker': speaker,
            'emotion': emotion,
            'speed': speed,
            'text': text
          }
        }
        // if audio already generated, request must contain id, so backend will overwrite existing audio
        if (maybeId) {
          request.id = maybeId
        }
        return request
      },
      securityHeaders() {
        return {
          'testH': 'testHV',
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
        }
      },
      onChangeGenerationState(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
        if (this.scenario.parameters[stateId]) {
          this.scenario.parameters[audioId] = this.tmp[generatedAudioId]
          this.$refs[playerId][0].load()
        } else if (!this.tmp[stateId]) {
          this.scenario.parameters[audioId] = this.tmp[loadedAudioId]
          this.$refs[playerId][0].load()
        }
      },
      genAudio(id, audio, speaker, generatedAudio, text, loadingStatus, name, emotion, speed) {
        const request = this.genAudioRequest(this.scenario.parameters[id], name, this.scenario.parameters[text], this.tmp[speaker], this.tmp[emotion], this.tmp[speed])
        const headers = {headers: this.securityHeaders()}
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий')
        } else {
          this.tmp[loadingStatus] = true
          this.$http.post(audioGeneratorApi, request, headers)
            .then(response => {
              this.handleGenRequest(id, audio, generatedAudio, response.data)
              this.tmp[loadingStatus] = false
            })
            .catch(error => {
              console.log(error)
              this.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
              this.tmp[loadingStatus] = false
            })
        }
      },
      handleGenRequest (id, audio, generatedAudio, data) {
        this.scenario.parameters[id] = data
        this.tmp[generatedAudio] = `/audios/${data}.wav`
        this.scenario.parameters[audio] = this.tmp[generatedAudio]
      },
      loadAudio(inputId, audioId, audioValue, generationType, audioName, player) {
        const input = document.querySelector(`#${inputId}`)
        if (input.files && input.files[0]) {
          if (!this.isSaved) {
            this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий')
          } else {
            this.handleUploadRequest(audioId, audioValue, generationType, input.files[0], audioName)
            this.$refs[player].load()
          }
        }
      },
      handleUploadRequest (audioId, audioValue, generationType, audioFile, audioName) {
        this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioId, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders())
          .then(response => {
            this.setAudioValue(audioId, generationType, audioValue, response)
          })
          .catch(error => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
          })
      },
      deleteAudio(audioId, audioValue, generationType1, generationType2) {
        this.$http.delete(`${audioDeleteApi}/${this.scenario.parameters[audioId]}`, {headers: this.prepareUploadHeaders()})
          .then((response) => {
            this.deleteAudioValue(audioId, generationType1, generationType2, audioValue)
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка удаления аудио. ')
          })
      },
      prepareMultipartAudio (audioFile, audioId, audioName, audioClient, audioScenario) {
        const audioFormData = new FormData()
        audioFormData.append('file', audioFile)
        audioFormData.append('name', audioName)
        audioFormData.append('client', audioClient)
        audioFormData.append('scenario', audioScenario)
        audioFormData.append('id', this.scenario.parameters[audioId])
        return audioFormData
      },
      prepareUploadHeaders () {
        return {
          'headers': {
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
            'Content-Type': 'multipart/form-data',
            'testH': 'testHV'
          }
        }
      },
      setAudioValue (audioId, generationType, audioValue, response) {
        this.scenario.parameters[audioId] = response.data
        this.tmp[generationType] = `/audios/${this.scenario.parameters[audioId]}.wav`
        this.scenario.parameters[audioValue] = this.tmp[generationType]
      },
      deleteAudioValue (audioId, generationType1, generationType2, audioValue) {
        this.scenario.parameters[audioId] = ''
        this.tmp[generationType1] = ''
        this.tmp[generationType2] = ''
        this.scenario.parameters[audioValue] = ''
      },
      load() {
        this.$http({
          url: api + '/' + this.name,
          headers: this.prepareSecurityHeader()
        }).then((response) => {
          console.log('opening scenario ' + JSON.stringify(response.data))
          this.scenario = response.data
          this.q1audio = '/audios/' + this.scenario.parameters.mainQuestionId + '.wav'
          this.onQuestionYesAudio = '/audios/' + this.scenario.parameters.onYesId + '.wav'
          this.onQuestionNoAudio = '/audios/' + this.scenario.parameters.onNoId + '.wav'
          this.isSaved = true
        }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки сценария. ')
        })
      },
      cancel() {
        if (this.$props.campaignid == 0) {
          this.$router.push('/scenarios/')
        } else {
          this.$router.push('/campaigns/' + this.$props.campaignid)
        }
      },
      closeModal () {
        this.showModal = false
        this.currentAudio = null
      },
      openModal (audioId, audioValue, generationType, audioName) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий')
        } else {
          this.showModal = true
          this.currentAudio = new FormData()
          this.currentAudio.append('audioId', audioId)
          this.currentAudio.append('audioValue', audioValue)
          this.currentAudio.append('generationType', generationType)
          this.currentAudio.append('audioName', audioName)
        }
      },
      confirmAction (value) {
        this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'))
        this.closeModal()
      },
      notSaved () {
        this.isSaved = false
      },
      loadState () {
        this.$http({
          url: PROFILES_API + '/activeState/' + this.loggedId,
          headers: this.prepareSecurityHeader()
        }).then((response) => {
          this.isActive = response.data
          if (!this.isActive) {
            openMessage({
              message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
              type: 'danger',
              showCloseButton: true
            })
          }
        }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].scenarios.errorToGetUserStatus)
        })
      },
      openNotificationWithType (type, message) {
        openNotification({
          title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
          message: message,
          type: type
        })
      }
    },
    data() {
      return {
        scenario: {
          template: 'yesnoonequestion',
          parameters: {
            mainQuestionId: '',
            mainQuestionAudio: '',
            mainQuestionText: '',
            mainGenerationState: true,
            mainSpeaker: 'oksana',
            mainEmotion: 'neutral',
            mainSpeed: 1,

            onYesId: '',
            onYesAudio: '',
            onYesText: '',
            onYesGenerationState: true,
            onYesSMSText: '',
            onYesSpeaker: 'oksana',
            onYesEmotion: 'neutral',
            onYesSpeed: 1,

            onNoId: '',
            onNoAudio: '',
            onNoText: '',
            onNoGenerationState: true,
            onNoSpeaker: 'oksana',
            onNoEmotion: 'neutral',
            onNoSpeed: 1

          },
          checkDuration: true
        },
        tmp: {
          mainGeneratedAudio: '',
          mainLoadedAudio: '',
          mainLoading: false,
          currentSpeakerMain: 'oksana',
          currentEmotionMain: 'neutral',
          currentSpeedMain: 1,

          onYesGeneratedAudio: '',
          onYesLoadedAudio: '',
          onYesLoading: false,
          currentSpeakerYes: 'oksana',
          currentEmotionYes: 'neutral',
          currentSpeedYes: 1,

          onNoGeneratedAudio: '',
          onNoLoadedAudio: '',
          onNoLoading: false,
          currentSpeakerNo: 'oksana',
          currentEmotionNo: 'neutral',
          currentSpeedNo: 1
        },
        speakerList: [
          {
            value: 'jane'
          },
          {
            value: 'oksana'
          },
          {
            value: 'alyss '
          },
          {
            value: 'omazh'
          },
          {
            value: 'zahar '
          },
          {
            value: 'ermil '
          }
        ],
        currentEmotion: 'neutral',
        emotionList: [
          {
            value: 'good'
          },
          {
            value: 'neutral'
          },
          {
            value: 'evil'
          }
        ],
        currentSpeed: 1,
        q1audio: '',
        onQuestionYesAudio: '',
        onQuestionNoAudio: '',
        isSaved: false,
        isActive: false,
        showModal: null,
        title: '',
        currentAudio: null
      }
    },
    created: function () {
      this.loadState()
      if (!this.$props.name) {
        console.log('creating new scenario')
        this.notSaved()
      } else {
        console.log('loading scenario: ' + !this.$props.name)
        this.load()
      }
      this.$watch('scenario.parameters.mainQuestionAudio', function () {
        this.$refs.mainPlayer.load()
      })
      this.$watch('scenario.parameters.onYesAudio', function () {
        this.$refs.onYesPlayer.load()
      })
      this.$watch('scenario.parameters.onNoAudio', function () {
        this.$refs.onNoPlayer.load()
      })

      if (this.loadedScenario) {
        this.isSaved = true
        if (this.scenario.isReady) {
          this.isReady = this.scenario.isReady
          this.scenario = this.loadedScenario
          this.scenario.isReady = this.isReady
        } else {
          this.scenario = this.loadedScenario
        }

        if (this.scenario.parameters.mainGenerationState) {
          this.tmp.mainGeneratedAudio = this.scenario.parameters.mainQuestionAudio
        } else {
          this.tmp.mainLoadedAudio = this.scenario.parameters.mainQuestionAudio
        }
        this.tmp.currentSpeakerMain = this.scenario.parameters.mainSpeaker || this.tmp.currentSpeakerMain
        this.tmp.currentEmotionMain = this.scenario.parameters.mainEmotion || this.tmp.currentEmotionMain
        this.tmp.currentSpeedMain = this.scenario.parameters.mainSpeed || this.tmp.currentSpeedMain


        if (this.scenario.parameters.onYesGenerationState) {
          this.tmp.onYesGeneratedAudio = this.scenario.parameters.onYesAudio
        } else {
          this.tmp.onYesLoadedAudio = this.scenario.parameters.onYesAudio
        }
        this.tmp.currentSpeakerYes = this.scenario.parameters.onYesSpeaker || this.tmp.currentSpeakerYes
        this.tmp.currentEmotionYes = this.scenario.parameters.onYesEmotion || this.tmp.currentEmotionYes
        this.tmp.currentSpeedYes = this.scenario.parameters.onYesSpeed || this.tmp.currentSpeedYes


        if (this.scenario.parameters.onNoGenerationState) {
          this.tmp.onNoGeneratedAudio = this.scenario.parameters.onNoAudio
        } else {
          this.tmp.onNoLoadedAudio = this.scenario.parameters.onNoAudio
        }
        this.tmp.currentSpeakerNo = this.scenario.parameters.onNoSpeaker || this.tmp.currentSpeakerNo
        this.tmp.currentEmotionNo = this.scenario.parameters.onNoEmotion || this.tmp.currentEmotionNo
        this.tmp.currentSpeedNo = this.scenario.parameters.onNoSpeed || this.tmp.currentSpeedNo
      }
    },
    beforeUpdate() {
      if (this.loadedScenario) {
        this.isSaved = true
        if (this.scenario.isReady) {
          this.isReady = this.scenario.isReady
          this.scenario = this.loadedScenario
          this.scenario.isReady = this.isReady
        } else {
          this.scenario = this.loadedScenario
        }

        if (this.scenario.parameters.mainGenerationState) {
          this.tmp.mainGeneratedAudio = this.scenario.parameters.mainQuestionAudio
        } else {
          this.tmp.mainLoadedAudio = this.scenario.parameters.mainQuestionAudio
        }
        // this.tmp.currentSpeakerMain = this.scenario.parameters.mainSpeaker || this.tmp.currentSpeakerMain
        // this.tmp.currentEmotionMain = this.scenario.parameters.mainEmotion || this.tmp.currentEmotionMain
        // this.tmp.currentSpeedMain = this.scenario.parameters.mainSpeed || this.tmp.currentSpeedMain

        if (this.scenario.parameters.onYesGenerationState) {
          this.tmp.onYesGeneratedAudio = this.scenario.parameters.onYesAudio
        } else {
          this.tmp.onYesLoadedAudio = this.scenario.parameters.onYesAudio
        }
        // this.tmp.currentSpeakerYes = this.scenario.parameters.onYesSpeaker || this.tmp.currentSpeakerYes
        // this.tmp.currentEmotionYes = this.scenario.parameters.onYesEmotion || this.tmp.currentEmotionYes
        // this.tmp.currentSpeedYes = this.scenario.parameters.onYesSpeed || this.tmp.currentSpeedYes

        if (this.scenario.parameters.onNoGenerationState) {
          this.tmp.onNoGeneratedAudio = this.scenario.parameters.onNoAudio
        } else {
          this.tmp.onNoLoadedAudio = this.scenario.parameters.onNoAudio
        }
        // this.tmp.currentSpeakerNo = this.scenario.parameters.onNoSpeaker || this.tmp.currentSpeakerNo
        // this.tmp.currentEmotionNo = this.scenario.parameters.onNoEmotion || this.tmp.currentEmotionNo
        // this.tmp.currentSpeedNo = this.scenario.parameters.onNoSpeed || this.tmp.currentSpeedNo
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import 'node_modules/bulma/sass/utilities/mixins';

  .spinner {
    margin-right: 5px;
  }

  .custom-file-input::-webkit-file-upload-button {
    visibility: hidden;
  }
  .custom-file-input::before {
    content: 'Select some files';
    display: inline-block;
    background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
    border: 1px solid #999;
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 700;
    font-size: 10pt;
  }
  .custom-file-input:hover::before {
    border-color: black;
  }
  .custom-file-input:active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
  }
  p {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// ScenarioQuestionYesNo.vue?7e808223